import React from 'react';
import * as S from './style';
import { FormStatusInfo, Label, Btn } from 'components';
import { ReactComponent as ImgDocWait } from 'assets/img/status/img_doc_wait.svg';

import * as PAGE_URL from 'router/PageUrl';

function DocWait(): React.ReactElement {
  return (
    <FormStatusInfo
      subTitle={['지원해주셔서 감사합니다.']}
      image={<ImgDocWait />}
      btnWidth={180}
      btn={
        <Btn
          height={44}
          fontStyle={'body2'}
          backGroundColor={'blue_900'}
          color={'gray_opacity_50'}
          href={PAGE_URL.SERVICE_SELECT.path}
        >
          {'홈으로 돌아가기'}
        </Btn>
      }
    >
      <S.CaptionWrapper>
        {[
          '가입 신청일 이후 7일 이내 서류 확인이 완료됩니다.',
          '진행 사항을 문자로 보내드리오니 잠시만 기다려주세요.',
        ].map((item, index) => (
          <Label
            key={index}
            contents={item}
            color={'gray_opacity_600'}
            fontStyle={'body2'}
          />
        ))}
      </S.CaptionWrapper>
    </FormStatusInfo>
  );
}

export default DocWait;
